import React, { useContext, useEffect, useRef, useState } from "react";
import { TableCell, TableRow, TableHead, IconButton, Typography, Button } from "@material-ui/core";
import MUIDataTable, { TableHead as MuiTableHead } from "mui-datatables";
import { makeStyles } from "@material-ui/core/styles";
import { GblContext } from "providers/formatter";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import CustomToolbar from "./CustomToolbar";
import { FaAngleDoubleDown, FaAngleDoubleRight } from "react-icons/fa";
import ReportBackDrop from "components/ReportBackDrop";
import { showReportByName } from "pages/Report/services";

const useStyles = makeStyles(() => ({
  btnColorCell: {
    backgroundColor: "#fff",
    color: "#000",
    "&:hover, &:focus": {
      backgroundColor: "#fff",
      color: "#000",
    },
    textTransform: "none",
  },
  colorCell: {
    backgroundColor: "#34558b",
    color: "#fff",
    position: "sticky",
    top: 0,
  },
  cellHeaderName: {
    fontWeight: "bold",
    paddingTop: 8,
    paddingBottom: 8,
  },
  cellHeaderNumber: {
    fontWeight: "bold",
    paddingTop: 8,
    paddingBottom: 8,
    borderBottom: "1px solid black",
  },
  cellHeader: {
    backgroundColor: "#B8CCE4",
    fontWeight: "bold",
    borderBottom: "1px solid black",
  },
  TableRow: {
    cursor: "pointer",
    paddingLeft: 0,
  },
  TableRowSub: {
    cursor: "default",
    paddingLeft: 0,
  },
  IconWrapper: {
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.10)",
      borderRadius: "50%",
    },
  },
}));

const Table = ({ basePath, dataTable, title, permissions, parameters, showReportLoader, hideReportLoader }) => {
  const { NumberFormat } = useContext(GblContext);
  const classes = useStyles();

  const [open, setOpen] = useState({});
  const [statusOpen, setStatusOpen] = useState(false);

  const toggleRow = (Id, Name) => {
    const newRowState = { ...open };
    newRowState[`${Id}${Name}`] = !newRowState[`${Id}${Name}`];
    setOpen(newRowState);
  };

  const expandAll = () => {
    setStatusOpen(true);
    const openSub = [];

    if (dataTable) {
      dataTable.map((el, i) => {
        if (el.children?.length > 0) {
          el.children.forEach((jItem) => {
            openSub.push({
              [`${jItem.Id}${jItem.Name}`]: true,
            });
            if (jItem.children?.length > 0) {
              jItem.children.forEach((kItem) => {
                openSub.push({
                  [`${kItem.Id}${kItem.Name}`]: true,
                });
              });
            }
          });
        }
        return el;
      });

      const result = openSub.reduce((acc, curr) => {
        return { ...acc, ...curr };
      }, {});
      setOpen(result);
    }

    const result = openSub.reduce((acc, curr) => {
      return { ...acc, ...curr };
    }, {});
    setOpen(result);
  };

  const collapseAll = () => {
    setStatusOpen(false);
    const openSub = [];
    dataTable.map((el, i) => {
      if (el.children?.length > 0) {
        el.children.forEach((jItem) => {
          if (jItem.children?.length > 0 && jItem.ThisYear === null) {
            openSub.push({
              [`${jItem.Id}${jItem.Name}`]: true,
            });
          } else {
            openSub.push({
              [`${jItem.Id}${jItem.Name}`]: false,
            });
          }
        });
      }
      return el;
    });
    const result = openSub.reduce((acc, curr) => {
      return { ...acc, ...curr };
    }, {});
    setOpen(result);
  };

  let shouldGet = useRef(true);
  useEffect(() => {
    if (shouldGet.current) {
      shouldGet.current = false;
      const openSub = [];
      if (dataTable) {
        dataTable.map((el, i) => {
          if (el.children?.length > 0) {
            el.children.forEach((jItem) => {
              if (jItem.children?.length > 0 && jItem.ThisYear === null) {
                openSub.push({
                  [`${jItem.Id}${jItem.Name}`]: true,
                });
              } else {
                // openSub.push({
                //   [`${jItem.Id}${jItem.Name}`]: false,
                // });
              }
            });
          }
          return el;
        });

        const result = openSub.reduce((acc, curr) => {
          return { ...acc, ...curr };
        }, {});

        setOpen(result);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const findTotal = (data) => {
    let dTotal = data.Name?.slice(0, 5) === "Total";
    if (dTotal) {
      return true;
    } else {
      return false;
    }
  };

  const columns = [
    {
      name: "Name",
      label: "Name",
      options: {
        customHeadRender: ({ label }) => {
          return (
            <TableCell align="center" className={classes.colorCell}>
              {label}
            </TableCell>
          );
        },
        customBodyRender: (value, data) => {
          return <b style={{ padding: 0 }}>{value}</b>;
        },
      },
    },
    {
      name: "ThisMonth",
      label: "This Month",
      options: {
        customHeadRender: ({ label }) => {
          return (
            <TableCell align="center" className={classes.colorCell}>
              {label}
            </TableCell>
          );
        },
        customBodyRender: (value) => {
          return <Typography align="center">{value === null ? null : <b>{NumberFormat(value)}</b>}</Typography>;
        },
      },
    },
    {
      name: "LastMonth",
      label: "Last Month",
      options: {
        customHeadRender: ({ label }) => {
          return (
            <TableCell align="center" className={classes.colorCell}>
              {label}
            </TableCell>
          );
        },
        customBodyRender: (value) => {
          return <Typography align="center">{value === null ? null : <b>{NumberFormat(value)}</b>}</Typography>;
        },
      },
    },
    {
      name: "MonthBudget",
      label: "Budget",
      options: {
        customHeadRender: ({ label }) => {
          return (
            <TableCell align="center" className={classes.colorCell}>
              {label}
            </TableCell>
          );
        },
        customBodyRender: (value) => {
          return <Typography align="center">{value === null ? null : <b>{NumberFormat(value)}</b>}</Typography>;
        },
      },
    },
    {
      name: "ThisYear",
      label: "This Year",
      options: {
        customHeadRender: ({ label }) => {
          return (
            <TableCell align="center" className={classes.colorCell}>
              {label}
            </TableCell>
          );
        },
        customBodyRender: (value) => {
          return <Typography align="center">{value === null ? null : <b>{NumberFormat(value)}</b>}</Typography>;
        },
      },
    },
    {
      name: "LastYear",
      label: "Last Year",
      options: {
        customHeadRender: ({ label }) => {
          return (
            <TableCell align="center" className={classes.colorCell}>
              {label}
            </TableCell>
          );
        },
        customBodyRender: (value) => {
          return <Typography align="center">{value === null ? null : <b>{NumberFormat(value)}</b>}</Typography>;
        },
      },
    },
    {
      name: "YearBudget",
      label: "Year Budget",
      options: {
        customHeadRender: ({ label }) => {
          return (
            <TableCell align="center" className={classes.colorCell}>
              {label}
            </TableCell>
          );
        },
        customBodyRender: (value) => {
          return <Typography align="center">{value === null ? null : <b>{NumberFormat(value)}</b>}</Typography>;
        },
      },
    },
  ];

  const printReport = async (viewBy) => {
    showReportLoader();
    await showReportByName("GL_FIN_PL", [
      { Name: "YearNo", Value: parameters.Year },
      { Name: "PeriodNo", Value: parameters.Period },
      { Name: "Revision", Value: parameters.BudgetRevision },
      { Name: "Departments", Value: parameters.Departments.join() },
      { Name: "ViewBy", Value: viewBy },
    ]);
    setTimeout(() => {
      hideReportLoader();
    }, 2000);
  };

  const options = {
    selectableRows: "none",
    filter: false,
    filterType: "dropdown",
    responsive: "standard",
    download: false,
    print: false,
    search: false,
    viewColumns: false,
    expandableRows: true,
    expandableRowsHeader: false,
    expandableRowsOnClick: false,
    pagination: false,
    customToolbar: () => {
      return (
        <CustomToolbar
          basePath={basePath}
          id={"PL"}
          dataTable={dataTable}
          permissions={permissions}
          printReport={printReport}
        />
      );
    },
    setTableProps: () => ({
      size: "small",
    }),
    isRowExpandable: (dataIndex) => {
      if (dataTable[dataIndex]?.hasOwnProperty("children") === false) {
        return false;
      }
      return true;
    },
    rowsExpanded: dataTable && dataTable.map((el, i) => i),
    renderExpandableRow: (rowData, rowMeta) => {
      const rowIndex = rowMeta.rowIndex;
      const subChild = dataTable[rowIndex].children;

      if (subChild && Array.isArray(subChild) && subChild.length > 0) {
        return subChild.map((subItem, index) => (
          <React.Fragment key={`sub${index}`}>
            <TableRow onClick={() => toggleRow(subItem.Id, subItem.Name)}>
              <TableCell style={{ paddingLeft: 25 }}>
                {subItem.children && (
                  <IconButton onClick={() => toggleRow(subItem.Id, subItem.Name)} size="small">
                    {open[`${subItem.Id}${subItem.Name}`] ? <ExpandMoreIcon /> : <ChevronRightIcon />}
                  </IconButton>
                )}
              </TableCell>

              {subItem.IsBold ? (
                <TableCell style={{ paddingLeft: 25 }} className={classes.cellHeaderName}>
                  {subItem.children ? <strong>{subItem.Name}</strong> : subItem.Name}
                </TableCell>
              ) : (
                <TableCell style={{ paddingLeft: 35 }}>{subItem.Name}</TableCell>
              )}

              <TableCell align="center" className={findTotal(subItem) ? classes.cellHeader : ""}>
                {subItem.ThisMonth === null ? null : NumberFormat(subItem.ThisMonth ?? 0)}
              </TableCell>
              <TableCell align="center" className={findTotal(subItem) ? classes.cellHeader : ""}>
                {subItem.LastMonth === null ? null : NumberFormat(subItem.LastMonth ?? 0)}
              </TableCell>
              <TableCell align="center" className={findTotal(subItem) ? classes.cellHeader : ""}>
                {subItem.MonthBudget === null ? null : NumberFormat(subItem.MonthBudget ?? 0)}
              </TableCell>
              <TableCell align="center" className={findTotal(subItem) ? classes.cellHeader : ""}>
                {subItem.ThisYear === null ? null : NumberFormat(subItem.ThisYear ?? 0)}
              </TableCell>
              <TableCell align="center" className={findTotal(subItem) ? classes.cellHeader : ""}>
                {subItem.LastYear === null ? null : NumberFormat(subItem.LastYear ?? 0)}
              </TableCell>
              <TableCell align="center" className={findTotal(subItem) ? classes.cellHeader : ""}>
                {subItem.YearBudget === null ? null : NumberFormat(subItem.YearBudget ?? 0)}
              </TableCell>
            </TableRow>

            {open[`${subItem.Id}${subItem.Name}`] &&
              subItem.children &&
              subItem.children.map((item, childIndex) => (
                <React.Fragment key={`child${childIndex}`}>
                  <TableRow className={classes.TableRowSub} onClick={() => toggleRow(item.Id, item.Name)}>
                    <TableCell style={{ paddingLeft: 40 }}>
                      {item.children && (
                        <IconButton onClick={() => toggleRow(item.Id, item.Name)} size="small">
                          {open[`${item.Id}${item.Name}`] ? <ExpandMoreIcon /> : <ChevronRightIcon />}
                        </IconButton>
                      )}
                    </TableCell>

                    {item.IsBold ? (
                      <TableCell style={{ paddingLeft: 35 }} className={classes.cellHeaderName}>
                        {item.Name}
                      </TableCell>
                    ) : (
                      <TableCell style={{ paddingLeft: 50 }}>{item.Name}</TableCell>
                    )}

                    <TableCell align="center" className={findTotal(item) ? classes.cellHeaderNumber : ""}>
                      {item.ThisMonth === null ? null : NumberFormat(item.ThisMonth ?? 0)}
                    </TableCell>
                    <TableCell align="center" className={findTotal(item) ? classes.cellHeaderNumber : ""}>
                      {item.LastMonth === null ? null : NumberFormat(item.LastMonth ?? 0)}
                    </TableCell>
                    <TableCell align="center" className={findTotal(item) ? classes.cellHeaderNumber : ""}>
                      {item.MonthBudget === null ? null : NumberFormat(item.MonthBudget ?? 0)}
                    </TableCell>
                    <TableCell align="center" className={findTotal(item) ? classes.cellHeaderNumber : ""}>
                      {item.ThisYear === null ? null : NumberFormat(item.ThisYear ?? 0)}
                    </TableCell>
                    <TableCell align="center" className={findTotal(item) ? classes.cellHeaderNumber : ""}>
                      {item.LastYear === null ? null : NumberFormat(item.LastYear ?? 0)}
                    </TableCell>
                    <TableCell align="center" className={findTotal(item) ? classes.cellHeaderNumber : ""}>
                      {item.YearBudget === null ? null : NumberFormat(item.YearBudget ?? 0)}
                    </TableCell>
                  </TableRow>

                  {open[`${item.Id}${item.Name}`] &&
                    item.children &&
                    item.children.map((subChild, subChildIndex) => (
                      <>
                        <TableRow
                          key={`subChild${subChildIndex}`}
                          className={classes.TableRowSub}
                          onClick={() => toggleRow(subChild.Id, subChild.Name)}
                        >
                          <TableCell style={{ paddingLeft: 60 }}>
                            {subChild.children && (
                              <IconButton onClick={() => toggleRow(subChild.Id, subChild.Name)} size="small">
                                {open[`${subChild.Id}${subChild.Name}`] ? <ExpandMoreIcon /> : <ChevronRightIcon />}
                              </IconButton>
                            )}
                          </TableCell>
                          <TableCell
                            style={{ paddingLeft: subChild.IsBold ? 30 : 70 }}
                            className={subChild.IsBold ? classes.cellHeaderName : ""}
                          >
                            {subChild.Name}
                          </TableCell>
                          <TableCell align="center" className={findTotal(subChild) ? classes.cellHeaderNumber : ""}>
                            {subChild.ThisMonth === null ? null : NumberFormat(subChild.ThisMonth ?? 0)}
                          </TableCell>
                          <TableCell align="center" className={findTotal(subChild) ? classes.cellHeaderNumber : ""}>
                            {subChild.LastMonth === null ? null : NumberFormat(subChild.LastMonth ?? 0)}
                          </TableCell>
                          <TableCell align="center" className={findTotal(subChild) ? classes.cellHeaderNumber : ""}>
                            {subChild.MonthBudget === null ? null : NumberFormat(subChild.MonthBudget ?? 0)}
                          </TableCell>
                          <TableCell align="center" className={findTotal(subChild) ? classes.cellHeaderNumber : ""}>
                            {subChild.ThisYear === null ? null : NumberFormat(subChild.ThisYear ?? 0)}
                          </TableCell>
                          <TableCell align="center" className={findTotal(subChild) ? classes.cellHeaderNumber : ""}>
                            {subChild.LastYear === null ? null : NumberFormat(subChild.LastYear ?? 0)}
                          </TableCell>
                          <TableCell align="center" className={findTotal(subChild) ? classes.cellHeaderNumber : ""}>
                            {subChild.YearBudget === null ? null : NumberFormat(subChild.YearBudget ?? 0)}
                          </TableCell>
                        </TableRow>

                        {open[`${subChild.Id}${subChild.Name}`] &&
                          subChild.children &&
                          subChild.children.map((lastChild, lastChildIndex) => (
                            <TableRow key={`lastChild${lastChildIndex}`} className={classes.TableRowSub}>
                              <TableCell />
                              <TableCell style={{ paddingLeft: 60 }}>{lastChild.Name}</TableCell>
                              <TableCell align="center" className={findTotal(subChild) ? classes.cellHeaderNumber : ""}>
                                {subChild.ThisMonth === null ? null : NumberFormat(subChild.ThisMonth ?? 0)}
                              </TableCell>
                              <TableCell align="center" className={findTotal(subChild) ? classes.cellHeaderNumber : ""}>
                                {subChild.LastMonth === null ? null : NumberFormat(subChild.LastMonth ?? 0)}
                              </TableCell>
                              <TableCell align="center" className={findTotal(subChild) ? classes.cellHeaderNumber : ""}>
                                {subChild.MonthBudget === null ? null : NumberFormat(subChild.MonthBudget ?? 0)}
                              </TableCell>
                              <TableCell align="center" className={findTotal(subChild) ? classes.cellHeaderNumber : ""}>
                                {subChild.ThisYear === null ? null : NumberFormat(subChild.ThisYear ?? 0)}
                              </TableCell>
                              <TableCell align="center" className={findTotal(subChild) ? classes.cellHeaderNumber : ""}>
                                {subChild.LastYear === null ? null : NumberFormat(subChild.LastYear ?? 0)}
                              </TableCell>
                              <TableCell align="center" className={findTotal(subChild) ? classes.cellHeaderNumber : ""}>
                                {subChild.YearBudget === null ? null : NumberFormat(subChild.YearBudget ?? 0)}
                              </TableCell>
                            </TableRow>
                          ))}
                      </>
                    ))}
                </React.Fragment>
              ))}
          </React.Fragment>
        ));
      }
      return null;
    },
  };

  const CustomTableHead = (props) => (
    <>
      <TableHead className={classes.colorCell}>
        <TableRow>
          <TableCell colSpan={2}>
            {!statusOpen ? (
              <Button className={classes.btnColorCell} onClick={() => expandAll()}>
                <FaAngleDoubleDown />
                Expand
              </Button>
            ) : (
              <Button className={classes.btnColorCell} onClick={() => collapseAll()}>
                <FaAngleDoubleRight />
                Collapse
              </Button>
            )}
          </TableCell>
          <TableCell colSpan={3} align="center" className={classes.colorCell}>
            Month To Date
          </TableCell>
          <TableCell colSpan={3} align="center" className={classes.colorCell}>
            Year To Date
          </TableCell>
        </TableRow>
      </TableHead>
      <MuiTableHead {...props} />
    </>
  );

  return (
    <div>
      {dataTable && (
        <MUIDataTable
          title={
            <Typography variant="h6" style={{ fontSize: "1.1111111111111112rem" }}>
              {title}
            </Typography>
          }
          data={dataTable ?? []}
          columns={columns}
          options={options}
          components={{ TableHead: CustomTableHead }}
        />
      )}
    </div>
  );
};

export default ReportBackDrop(Table);
